// extracted by mini-css-extract-plugin
export var option = "_az-0";
export var optionCard = "_az-f";
export var optionContent = "_az-g";
export var optionIcon = "_az-i";
export var optionIconBox = "_az-h";
export var optionLabel = "_az-j";
export var optionPill = "_az-m";
export var optionPillBadge = "_az-p";
export var optionPillIcon = "_az-n";
export var optionPillLabel = "_az-o";
export var optionRadio = "_az-k";
export var optionRadioInner = "_az-l";
export var optionReveal = "_az-2";
export var optionRevealDelay0 = "_az-3";
export var optionRevealDelay1 = "_az-4";
export var optionRevealDelay10 = "_az-d";
export var optionRevealDelay11 = "_az-e";
export var optionRevealDelay2 = "_az-5";
export var optionRevealDelay3 = "_az-6";
export var optionRevealDelay4 = "_az-7";
export var optionRevealDelay5 = "_az-8";
export var optionRevealDelay6 = "_az-9";
export var optionRevealDelay7 = "_az-a";
export var optionRevealDelay8 = "_az-b";
export var optionRevealDelay9 = "_az-c";
export var optionSelected = "_az-1";